import {NgModule} from '@angular/core'
import {TableOfContentComponent} from './table-of-content.component'
import {TocItemComponent} from './toc-item/toc-item.component'
import {NgClass} from '@angular/common'
import {TranslocoModule} from '@ngneat/transloco'

@NgModule({
  declarations: [TableOfContentComponent, TocItemComponent],
  exports: [TableOfContentComponent, TocItemComponent],
  imports: [NgClass, TranslocoModule],
})
export class TableOfContentModule {}
